import { render } from "./FooterView.vue?vue&type=template&id=11501840"
const script = {}

import "./FooterView.vue?vue&type=style&index=0&id=11501840&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__